class GroupTesterHomeController {
    constructor($uibModal, $window, $route, $routeParams, $location, $browser, TraceHubExService, ModalService, UserDetailsApi, UsersAdminServiceApi, GroupTesterSimServiceApi, UtpSimServiceApi, UtpTestExecutionServiceApi, ReportServiceApi, ngProgressFactory, toastr, AppServiceApi, CapacityServiceApi, PermissionsServiceApi, SettingsService) {
        this.$onInit = () => {
            this.init();
            // SIGNAL R SECTION
            this.SettingsService.getSettings().then((response) => {
                const appSettings = response.data;
                this.TraceHubExService.connectWithSpecificTransport('GroupTesterHomeController', appSettings.SignalRTransport);
                this.TraceHubExService.on('GroupTesterHomeController', 'onInit', (connId) => {
                    this.state.connectionId = connId;
                });
                this.TraceHubExService.on('GroupTesterHomeController', 'onSimStatusChanging', (args) => {
                    if (args.UserId === this.userDetails.Id) {
                        this.simStatusChanging = true;
                        this.traceProgress.start();
                    }
                });
                // The status of a sim has changed so one has started or stopped, args.simUpdateType will indicate whether its a start or stop
                this.TraceHubExService.on('GroupTesterHomeController', 'onSimStatusChange', (args) => {
                    /* If the sim changins status is not for this user then ignore this event */
                    if (args.UserId !== this.state.SelectedTesterId) {
                        return;
                    }
                    /* Show error msg if any */
                    if (args.ErrorMessage !== '' && args.ErrorMessage !== null) {
                        this.toastr.warning(args.ErrorMessage);
                    }
                    if (args.Status === 'Starting' || args.Status === 'Stopping') {
                        // For the user the difference between 'Starting' and 'Started' means nothing - they would only care that the sim is usable
                        // ie. 'Started'. Same for 'Stopping' vs 'Stopped'
                        return;
                    }
                    // If we are here then we have some action to take
                    // default case is to update the list as there is no harm in it
                    let req = {
                        TesterId: this.state.SelectedTesterId,
                        SimId: 0
                    };
                    // We no go back and get the list of sims from the DB?
                    this.GroupTesterSimServiceApi.getSimulators(req).
                        then((response) => {
                        this.state = response.data;
                        this.simStatusChanging = false;
                        this.traceProgress.complete();
                        this.setButtonStatus();
                    });
                });
                // END SIGNAL R SECTION
            });
        };
        this.$onDestroy = () => {
            this.TraceHubExService.stop('GroupTesterHomeController');
        };
        this.init = () => {
            this.userDetails = null;
            this.state = {
                SelectedTesterId: 0,
                SelectedSimId: 0,
                Tester: { Id: 0, Name: '' },
                SimsWithStatus: [],
                connectionId: '',
                overTheShoulder: false
            };
            this.allButtonActive = true;
            this.dataLoaded = false;
            this.simStatusChanging = false;
            this.blockingError = '';
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.traceProgress.start();
            this.UserDetailsApi.get().then((response) => {
                let connectedUser = response.data;
                // Get our user details
                this.userDetails = connectedUser;
                // });
                let req = {
                    TesterId: this.userDetails.Id,
                    SimId: 0
                };
                // If routed from over the shoulder
                if (this.userDetails.IsSupport && this.routeParams.testerId) {
                    this.state.overTheShoulder = true;
                    req.TesterId = this.routeParams.testerId;
                }
                this.state.SelectedTesterId = req.TesterId;
                this.GroupTesterSimServiceApi.getSimulators(req).then((response) => {
                    this.state = response.data;
                    this.dataLoaded = true;
                    this.traceProgress.complete();
                    this.setButtonStatus();
                    this.state.SimsWithStatus.forEach(element => {
                        if (!_.isNil(element.LockingError)) {
                            this.toastr.error(element.LockingError);
                        }
                    });
                });
            }, () => {
                this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                this.window.location.href =
                    this.browser.baseHref() + 'account/login';
                return;
            });
            this.AppServiceApi.settings().then((response) => {
                this.enableRUF = response.data.EnableRUF;
                this.staticSimReports = response.data.StaticSimReports;
                this.testCaseDesignEnabled = response.data.EnableRUFComponents.some(c => c.toLowerCase() === 'testcasedesign');
            });
        };
        this.openTestPreparation = (sim) => {
            let route = `/TestPreparation/${sim.Id}`;
            this.location.path(route);
        };
        this.showReport = (sim) => sim.SimTypeName === 'Static' ? this.staticSimReports : true;
        this.simStartStopButton = (sim) => {
            let simStartStopRequest = {
                TesterId: this.state.SelectedTesterId,
                SimId: sim.Id
            };
            // Start simulator if it is currently stopped or vice verse
            this.simStatusChanging = true;
            if (sim.IsRunning) {
                this.GroupTesterSimServiceApi.isSimulatorLocked(simStartStopRequest).then((response) => {
                    let lockData = response.data;
                    if (lockData.IsLocked && _.isNil(lockData.LockingError)) {
                        this.stopOtherUsersSimulator(sim, lockData.LockingSSOUserDetails['IdPEmail']);
                    }
                    else if (!_.isNil(lockData.LockingError)) {
                        this.toastr.error(lockData.LockingError);
                    }
                    else {
                        this.stopSimulatorInstance(sim);
                    }
                });
            }
            else {
                this.UtpSimServiceApi.isAlreadyrunningInstance(sim.Id, this.state.SelectedTesterId).
                    then((response) => {
                    if (response.data) {
                        this.toastr.error('Simulator already started by other user');
                        this.GroupTesterSimServiceApi.getSimulators(simStartStopRequest).
                            then((response) => {
                            this.state = response.data;
                            this.setButtonStatus();
                            return;
                        });
                    }
                    else {
                        this.traceProgress.start();
                        this.simStatusChanging = true;
                        // starting the sim so disable button
                        this.allButtonActive = false;
                        this.UtpSimServiceApi.startSimulator(sim.Id, this.state.SelectedTesterId).then((response) => {
                            let simResp = response.data;
                            if (!simResp.success) {
                                this.simStatusChanging = false;
                                this.traceProgress.complete();
                                if (simResp.errors.length > 0) {
                                    this.toastr.error(simResp.errors[0]);
                                }
                                else {
                                    this.toastr.error('Simulator failed to start');
                                }
                                this.setButtonStatus();
                            }
                        });
                    }
                });
            }
            this.simStatusChanging = false;
        };
        this.setButtonStatus = () => {
            this.allButtonActive = true;
            let counter;
            for (counter = 0; counter < this.state.SimsWithStatus.length; counter++) {
                if (this.state.SimsWithStatus[counter].IsRunning) {
                    this.allButtonActive = false;
                }
            }
        };
        this.simOpenButton = (sim) => {
            this.CapacityServiceAPI.isCapacitySim(sim.Id).then((response) => {
                if (response.data) {
                    this.openCapacitySimHome(this.state.SelectedTesterId, sim.Id);
                }
                else {
                    this.openTestSuite(this.state.SelectedTesterId, sim.Id);
                }
            });
        };
        this.openTestSuite = (groupTesterId, simId) => {
            let route = `/TestExecution/${groupTesterId}/${simId}`;
            this.location.path(route);
        };
        this.openCapacitySimHome = (groupTesterId, simId) => {
            let route = `/Capacity/${groupTesterId}/${simId}`;
            this.location.path(route);
        };
        this.stopOtherUsersSimulator = (sim, userText) => {
            let modalOptions = {
                backdrop: 'static',
                actionButtonText: 'OK',
                closeButtonText: 'Cancel',
                headerText: 'Simulator Locked',
                bodyText: userText + ' is currently testing with this simulator. Are you sure you want to stop the simulator ?'
            };
            this.ModalService.showModal({}, modalOptions).then(() => {
                this.UtpTestExecutionServiceApi.stopRunningTest(this.state.SelectedTesterId, sim.Id).then((response) => {
                    this.stopSimulatorInstance(sim);
                });
            });
        };
        this.stopSimulatorInstance = (sim) => {
            this.simStatusChanging = true;
            this.traceProgress.start();
            this.UtpSimServiceApi.stopSimulatorInstance(sim.Id, this.state.SelectedTesterId).then((response) => {
                let simStopResponse = response.data;
                if (!simStopResponse.success) {
                    // stop simulator instance only returns one error when detected, so no need to show all in the list
                    if (simStopResponse.errors.length > 0) {
                        this.toastr.warning(simStopResponse.errors[0]);
                    }
                    else {
                        this.toastr.error('Simulator failed to stop');
                    }
                    this.simStatusChanging = false;
                    this.traceProgress.complete();
                }
            });
        };
        this.simConfigureButton = (simulator) => {
            let groupTesterId = this.state.SelectedTesterId;
            let isSupportUser = this.userDetails.IsSupport;
            let modalInstance = this.uibModal.open({
                backdrop: 'static',
                animation: true,
                component: 'configureSimulator',
                size: 'xl',
                resolve: {
                    simulator: () => {
                        return simulator;
                    },
                    userId: () => {
                        return groupTesterId;
                    },
                    isSupportUser: () => {
                        return isSupportUser;
                    },
                    liveSimulationData: () => {
                        return simulator.LiveSimulationData;
                    }
                }
            });
            modalInstance.result.then(() => {
                // TODO: success callback
            }, () => {
                // dismiss case
            });
        };
        this.openReport = (simulator, report) => {
            const selectedSim = { id: simulator.Id, type: simulator.SimTypeName };
            if (report.Name === 'CapacityReport') {
                this.uibModal.open({
                    animation: true,
                    size: 'md',
                    backdrop: 'static',
                    component: 'capacityReport',
                    resolve: {
                        capacityReport: report
                    }
                });
            }
            else {
                this.uibModal.open({
                    animation: true,
                    size: 'md',
                    backdrop: 'static',
                    component: 'externalReport',
                    resolve: {
                        report: report,
                        user: this.state.overTheShoulder ? this.UsersAdminServiceApi.singleUser(this.state.SelectedTesterId) : this.userDetails,
                        simulator: selectedSim
                    }
                });
            }
        };
        this.window = $window;
        this.browser = $browser;
        this.uibModal = $uibModal;
        this.ModalService = ModalService;
        this.UserDetailsApi = UserDetailsApi;
        this.UsersAdminServiceApi = UsersAdminServiceApi;
        this.toastr = toastr;
        this.location = $location;
        this.route = $route;
        this.routeParams = $routeParams;
        this.GroupTesterSimServiceApi = GroupTesterSimServiceApi;
        this.UtpSimServiceApi = UtpSimServiceApi;
        this.UtpTestExecutionServiceApi = UtpTestExecutionServiceApi;
        this.ngProgressFactory = ngProgressFactory;
        this.TraceHubExService = TraceHubExService;
        this.ReportServiceApi = ReportServiceApi;
        this.AppServiceApi = AppServiceApi;
        this.CapacityServiceAPI = CapacityServiceApi;
        this.PermissionsServiceApi = PermissionsServiceApi;
        this.SettingsService = SettingsService;
    }
}
angular.module('app').component('groupTesterHome', {
    bindings: {},
    templateUrl: 'scripts/app/partials/GroupTester/group-tester-home.tpl.html',
    controllerAs: 'vm',
    controller: GroupTesterHomeController
});
